import React from 'react';

import { func_validation, func_cookieSetting, func_datetime } from 'functions';
import { Button } from 'components/buttons/Button';

export const licenseColumns = {
    // Columns Array
    getColumns,

    // Columns
    getColumns_numbering,
    getColumns_license,
    getColumns_dateStarted,
    getColumns_chargeMethod,
    getColumns_monthlyCharges,
    getColumns_licenseKey,
    getColumns_deviceId,
    getColumns_deviceName,
    getColumns_remarks,
    getColumns_status,
    getColumns_lastResetDate,
    getColumns_deletedDate,
}

function getColumns(props) {
    return [
        getColumns_numbering(),
        getColumns_license(props),
        getColumns_dateStarted(),
        getColumns_chargeMethod(),
        getColumns_monthlyCharges(),
        getColumns_licenseKey(props),
        getColumns_deviceId(),
        getColumns_deviceName(),
        getColumns_remarks(),
        getColumns_status(),
        getColumns_lastResetDate(),
        getColumns_deletedDate(),
    ];
}

function getColumns_numbering() {
    let columnClassName = "distributorPortal-companyOverview-tableColumn-numbering";

    return {
        headerCellClassName: columnClassName + " ",
        id: "numbering",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let rowObj = func_validation.getObjectPropertyValue(props, "row");
            let rowIdx = func_validation.getObjectPropertyValue(rowObj, "index");
            rowIdx += 1;

            return (
                <div className={"noWrap-text-ellipsis"}>{rowIdx}</div>
            );
        },
        width: 80
    }
}


function getColumns_license(props) {
    const { packageList } = props;
    
    let columnClassName = "distributorPortal-companyOverview-tableColumn-license";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "License Type",
        // isHeaderColumnSortable: true,
        // sortValue: "license"
        id: "license",
        accessor: "packageid",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let id = func_validation.isNumberValid(value)? value: "-";

            let value_formatted = "-";
            if (func_validation.isArrayNotEmpty(packageList)) {
                for (let i = 0; i < packageList.length; i++) {
                    let packageId = func_validation.getObjectPropertyValue(packageList[i], "packageId");
                    let packageName = func_validation.getObjectPropertyValue(packageList[i], "packageName");

                    if (id == packageId) {
                        value_formatted = packageName;
                        break;
                    }
                }
            }

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_dateStarted() {
    let columnClassName = "distributorPortal-companyOverview-tableColumn-dateStarted";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Date Started",
        // isHeaderColumnSortable: true,
        // sortValue: "dateStarted"
        id: "dateStarted",
        accessor: "createdDate",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = "-";
            if (!isNaN(new Date(value)))
                value_formatted = func_datetime.convertDateTimeToLocal(value, "DD/MM/YYYY");

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_chargeMethod() {
    let columnClassName = "distributorPortal-companyOverview-tableColumn-chargeMethod";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Charging Method",
        // isHeaderColumnSortable: true,
        // sortValue: "chargeMethod"
        id: "chargeMethod",
        accessor: "chargeMethod",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_monthlyCharges() {
    let columnClassName = "distributorPortal-companyOverview-tableColumn-monthlyCharges";

    return {
        headerCellClassName: columnClassName + " justify-content-start",
        Header: "Monthly Charges",
        // isHeaderColumnSortable: true,
        // sortValue: "monthlyCharges"
        id: "monthlyCharges",
        accessor: "monthlyCharges",
        bodyCellClassName: columnClassName + " justify-content-end",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = "-";
            if (func_validation.isNumberValid(value)) {
                value_formatted = func_cookieSetting.getFormattedPrice(value, { currencyDisabled: true });
            }

            return (
                <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_licenseKey(props) {
    let columnClassName = "distributorPortal-companyOverview-tableColumn-licenseKey";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "License Key",
        id: "licenseKey",
        accessor: "licenseKey",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_deviceId() {
    let columnClassName = "distributorPortal-companyOverview-tableColumn-deviceId";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Device ID",
        id: "deviceId",
        accessor: "deviceId",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_deviceName() {
    let columnClassName = "distributorPortal-companyOverview-tableColumn-deviceName";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Device Name",
        id: "deviceName",
        accessor: "deviceName",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_remarks() {
    let columnClassName = "distributorPortal-companyOverview-tableColumn-remarks";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Tag (Remark)",
        id: "remarks",
        accessor: "remarks",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_status() {
    let columnClassName = "distributorPortal-companyOverview-tableColumn-status";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Status",
        id: "status",
        accessor: "status",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = value ? (
                <span style={{ color: 'green' }}>Active</span>
            ) : (
                <span style={{ color: 'red' }}>Removed</span>
            );

            return (
                <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_lastResetDate() {
    let columnClassName = "distributorPortal-companyOverview-tableColumn-lastResetDate";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Last Reset Date",
        id: "lastResetDate",
        accessor: "lastResetDate",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_deletedDate() {
    let columnClassName = "distributorPortal-companyOverview-tableColumn-deletedDate";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Deleted Date",
        id: "deletedDate",
        accessor: "deletedDate",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
            );
        },
    }
}